// extracted by mini-css-extract-plugin
module.exports = {"departments":"wi-z","departmentHeading":"xi-z","departmentSection":"yi-z","departmentName":"zi-z","departmentLink":"Ai-z","expandIcon":"Bi-z"};